import type { VoidFunctionComponent } from 'react';

import IssueDetailsDependencySection from '../DependencySection';

/**
 * VulnerabilityIssueDetailsDependency displays the dependency info
 * for the package which flagged this vulnerability info.
 */
const VulnerabilityIssueDetailsDependency: VoidFunctionComponent = () => (
  <IssueDetailsDependencySection />
);

export default VulnerabilityIssueDetailsDependency;
